export enum PROVIDER_ID {
  PERA_WALLET = 'Pera Wallet',
  // WALLET_CONNECT = 'Wallet Connect',
  MYALGO_WALLET = 'MyAlgo Wallet',
  ALGO_SIGNER = 'Algo Signer'
}

export const NODE_SERVER = process.env.NEXT_PUBLIC_NODE_URL || ''
/** @todo make sure tokens aren't exposed... */
export const NODE_TOKEN = process.env.NEXT_PUBLIC_NODE_TOKEN || ''

export const NODE_PORT = process.env.NEXT_PUBLIC_NODE_PORT || ''
